<template>
    <Main v-if="!state.isStart" @start="start"></Main>
    <template v-else>
        <Content v-if="state.step > 0 && state.step < 4" @next="next" @prev="prev" :step="state.step" :value="state.currentData"></Content>
        <Complete v-else-if="state.step > 4" @prev="prev" @complete="complete"></Complete>
        <CommentWrite v-else-if="state.step === 4" @next="next" @prev="prev" :value="eventData.myComment"></CommentWrite>
    </template>
</template>

<script lang="ts">
    import { reactive, watch } from "@/BaseComponent";
    import Content from "./content.vue";
    import CommentWrite from "./comment.vue";
    import Complete from "./complete.vue";
    import Main from "./main.vue";

    export default {
        props: {
            title: {
                type: String,
                default: "",
            },
            step: {
                type: Number,
                default: 0,
            },
        },
        emits: ["complete", "update:step"],
        components: { Main, Content, CommentWrite, Complete },
        setup(props: any, { emit }: any) {
            const state = reactive({
                isStart: false,
                step: props.step as number, // 1 ~ 3 - 체크박스, 4 - 코멘트
                currentData: [] as number[],
            });

            const eventData = reactive({
                step1: [] as number[],
                step2: [] as number[],
                step3: [] as number[],
                myComment: "" as string,
            });

            const start = () => {
                state.isStart = true;
                if (state.step < 1) {
                    state.step += 1;
                    emit("update:step", state.step);
                }
            };

            const next = (value: number[] | string) => {
                if (value) saveEventData(value);
                state.step += 1;
                if (state.step === 1) state.currentData = eventData.step1;
                else if (state.step === 2) state.currentData = eventData.step2;
                else if (state.step === 3) state.currentData = eventData.step3;
                emit("update:step", state.step);
            };

            const prev = (value: number[] | string) => {
                if (value) saveEventData(value);
                state.step -= 1;
                if (state.step === 1) state.currentData = eventData.step1;
                else if (state.step === 2) state.currentData = eventData.step2;
                else if (state.step === 3) state.currentData = eventData.step3;
                emit("update:step", state.step);
            };

            const saveEventData = (value: number[] | string) => {
                if (Array.isArray(value)) {
                    if (state.step === 1) eventData.step1 = value;
                    else if (state.step === 2) eventData.step2 = value;
                    else if (state.step === 3) eventData.step3 = value;
                } else {
                    if (state.step === 4 && !Array.isArray(value)) eventData.myComment = value;
                }
            };

            const complete = () => {
                emit("complete", eventData);
            };

            watch(
                () => state.step,
                () => {
                    document.body.style.overflow = "hidden";
                },
            );

            return {
                state,
                eventData,
                start,
                next,
                prev,
                complete,
            };
        },
    };
</script>

<style scoped></style>
